import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { GuideModule } from '../../shared-components/guide/guide.module';
import { LotMiniGalleryModule } from '../../shared-components/lot-mini-gallery/lot-mini-gallery.module';
import { LotBidAmountModule } from '../../shared-components/lot-bid-amount/lot-bid-amount.module';
import { BidLeaderStatusModule } from '../../shared-components/bid-leader-status/bid-leader-status.module';

import { BidsGuideDemoRowComponent } from './bids-guide-host/bids-guide-demo-row.component';
import { BidsGuideService } from './services/bids-guide.service';

@NgModule({
  declarations: [BidsGuideDemoRowComponent],
  imports: [
    CommonModule,
    NzTableModule,
    LotMiniGalleryModule,
    NzButtonModule,
    LotBidAmountModule,
    BidLeaderStatusModule,
    TranslateModule,
    NzTagModule,
    NzGridModule,
    GuideModule,
    NzIconModule,
  ],
  exports: [BidsGuideDemoRowComponent],
  providers: [BidsGuideService],
})
export class BidsGuideModule {}
